import { css } from 'react-emotion';

const styles = {
	accountHolder: css`
		.web-ui-components & {
			height: auto;
			min-height: 14px;
		}
	`,
	disabledVM: css`
		.vm .web-ui-components & {
			border: 1px solid #8b929c;
			color: #8b929c;

			svg {
				fill: #8b929c;
			}

			.c-a-button__title {
				color: #8b929c;
			}
		}
	`,
};

export default styles;
